import React from "react";

import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { RestrictedArea } from "@scenes/restrictedArea";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { ProfileNavigation } from "@common/profileNavigation";
import { Props } from "./types";
import { Navigation } from "./navigation";
import { Synthesis } from "./synthesis";
import { TimeSheet } from "./timeSheet";
import styles from "./styles.scss";

function PersonalSpacePage({ slug }: Props) {
  return (
    <WorkspaceContext type="planzone">
      <div className={styles.planzone}>
        <div className={styles.header}>
          <Navigation />
          <div className={styles.profileNavigation}>
            <AssistantShortcut />
            <Notifications />
            <ProfileNavigation />
          </div>
        </div>
        <div className={styles.main}>
          <RestrictedArea areas={["personalTimesheet", "personalSynthesis"]}>
            {({ canAccessPersonalSynthesis, canAccessPersonalTimesheet }) =>
              slug === "timeSheet" ? (
                canAccessPersonalTimesheet && <TimeSheet />
              ) : canAccessPersonalSynthesis ? (
                <Synthesis />
              ) : (
                <TimeSheet />
              )
            }
          </RestrictedArea>
        </div>
      </div>
    </WorkspaceContext>
  );
}

export { PersonalSpacePage };
